import { LOCATION_CHANGE } from 'redux-first-history';

import updateCanonical from 'common/helpers/updateCanonical';

const metaMiddleware = () => (next) => (action) => {
  if (action.type === LOCATION_CHANGE) {
    updateCanonical(action.payload.location.pathname);
  }

  return next(action);
};

export default metaMiddleware;
